import useTranslation from 'next-translate/useTranslation';

// Utils
import { post } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// Endpoints
import { RELAUNCH_SOCIAL_PROFILE_DATA } from '@/lib/routes/apiEndpoints';

// Hooks
import useStateWithReset from '@/utils/hooks/utils/useStateWithReset';

// Components
import Button from '@/components/base/Button';
import InfoBanner from '@/components/base/InfoBanner/CompoundBanner';

// Types
import type { SocialProfileTypeWithoutAuthStatus } from '@/utils/hooks/swr/useSocialProfile';

type RelaunchButtonBlockProps = {
    socialProfile: SocialProfileTypeWithoutAuthStatus;
    onRelaunch: () => void;
};

const RelaunchButtonBlock = ({ socialProfile, onRelaunch }: RelaunchButtonBlockProps) => {
    const { t } = useTranslation('commons');
    const [relaunchStatus, setRelaunchStatus, resetRelaunchStatus] = useStateWithReset<{
        isLoading: boolean;
        error: boolean;
    }>({
        isLoading: false,
        error: false
    });

    const relaunchData = async () => {
        setRelaunchStatus({
            error: false,
            isLoading: true
        });
        try {
            await post(
                injectEndpointUrlParams(RELAUNCH_SOCIAL_PROFILE_DATA, {
                    SPID: socialProfile?.id
                })
            );
            onRelaunch();
        } catch (e) {
            setRelaunchStatus({
                error: true,
                isLoading: false
            });
        }
    };
    return (
        <>
            {relaunchStatus.error ? (
                <InfoBanner className="mb-4">
                    <InfoBanner.Icon />
                    <InfoBanner.Content message={t('modal_first_stats_status.error.relaunch')} />
                    <InfoBanner.Close onClose={resetRelaunchStatus} />
                </InfoBanner>
            ) : null}
            <Button
                isLoading={relaunchStatus?.isLoading}
                onClick={relaunchData}
                className="mx-auto">
                {t('retry')}
            </Button>
        </>
    );
};

export default RelaunchButtonBlock;
